export class QuestionnaireDeleteRequest {
  questionnaireId!: string
  constructor(questionnaireId: string) {
    this.questionnaireId = questionnaireId
  }
}
